// src/pages/admin/AdminDashboard.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/admin/dashboard");
        setData(res.data);
      } catch {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <div>Loading dashboard…</div>;
  if (!data) return <div>Failed to load dashboard</div>;

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">Admin Overview</h1>

      <div className="grid md:grid-cols-4 gap-4">
        <Stat title="Users" value={data.users} />
        <Stat title="Orders" value={data.orders} />
        <Stat title="Revenue" value={`₹${data.revenue}`} />
        <Stat title="Pending Tickets" value={data.pendingTickets} />
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <List
          title="Recent Orders"
          items={data.recentOrders}
          render={(o) =>
            `${o.user?.email || "User"} → ${o.service?.name}`
          }
        />

        <List
          title="Recent Users"
          items={data.recentUsers}
          render={(u) => `${u.name} (${u.email})`}
        />
      </div>
    </div>
  );
}

function Stat({ title, value }) {
  return (
    <div className="card-glass p-4">
      <div className="text-sm text-gray-400">{title}</div>
      <div className="text-xl font-bold">{value}</div>
    </div>
  );
}

function List({ title, items, render }) {
  return (
    <div className="card-glass p-5">
      <h2 className="font-semibold mb-3">{title}</h2>
      {!items || items.length === 0 ? (
        <p className="text-sm text-gray-400">No recent data</p>
      ) : (
        items.map((i) => (
          <div
            key={i._id}
            className="text-sm text-gray-300 border-b border-white/5 py-2"
          >
            {render(i)}
          </div>
        ))
      )}
    </div>
  );
}
